import {
  addMonthsToYmd,
  dayOfWeekUTC,
  daysInMonth,
  parseYmd,
} from '../../../utils/date';

function pad(value) {
  return String(value).padStart(2, '0');
}

export function monthKey(ymd) {
  const { year, month } = parseYmd(ymd);
  return `${year}-${pad(month)}`;
}

export function monthParts(key) {
  const [year, month] = key.split('-').map(Number);
  return { year, month };
}

export function shiftMonthKey(key, offset) {
  return addMonthsToYmd(`${key}-01`, offset).slice(0, 7);
}

export function monthLabel(key) {
  const [year, month] = key.split('-');
  return `${year}년 ${Number(month)}월`;
}

function monthRangeEnd(key) {
  const [year, month] = key.split('-').map(Number);
  return `${key}-${pad(daysInMonth(year, month))}`;
}

function inRange(date, start, end) {
  return date && date >= start && date <= end;
}

function addEvent(map, date, event) {
  if (!map[date]) map[date] = [];
  map[date].push(event);
}

export function collectEvents(rows, months, today) {
  const start = `${months[0]}-01`;
  const end = monthRangeEnd(months[months.length - 1]);
  const events = {};

  rows.forEach((row) => {
    if (row.resign_date) return;
    const term = row.current_term || {};
    if (inRange(term.probation_end_date, start, end)) {
      addEvent(events, term.probation_end_date, {
        key: `${row.user_id}-probation`,
        row,
        type: '수습',
        tone: term.probation_end_date < today ? 'slate' : 'red',
      });
    }
    if (inRange(term.end_date, start, end)) {
      const urgent = term.end_date < today || row.status?.key === 'expired';
      const warning = row.status?.key === 'urgent' || row.status?.key === 'warning';
      addEvent(events, term.end_date, {
        key: `${row.user_id}-contract`,
        row,
        type: '계약',
        tone: urgent ? 'red' : warning ? 'amber' : 'green',
      });
    }
  });

  Object.values(events).forEach((items) => {
    items.sort((a, b) => {
      const typeRank = (a.type === '수습' ? 0 : 1) - (b.type === '수습' ? 0 : 1);
      return typeRank || a.row.name.localeCompare(b.row.name, 'ko-KR');
    });
  });
  return events;
}

export function buildCells(key) {
  const [year, month] = key.split('-').map(Number);
  const total = daysInMonth(year, month);
  const firstDow = dayOfWeekUTC(`${key}-01`);
  const cells = [];
  for (let i = 0; i < 42; i += 1) {
    const day = i - firstDow + 1;
    cells.push(day >= 1 && day <= total ? `${key}-${pad(day)}` : null);
  }
  return cells;
}

export function eventColor(tone) {
  if (tone === 'red') return { border: '#b91c1c', background: '#dc2626', color: '#fff' };
  if (tone === 'amber') return { border: '#b45309', background: '#f59e0b', color: '#111827' };
  if (tone === 'green') return { border: '#15803d', background: '#16a34a', color: '#fff' };
  return { border: '#475569', background: '#64748b', color: '#fff' };
}
